import actionCreator from "helpers/actionCreator"
import { handleSetPage } from "helpers/compositeSecuritiesDetails"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeCompositeExposureContributors", {
  setPage: {
    props: ["page"],
    track: false,
  },
}, {
  track: true,
})

export const queryStringReducers = {
  [Types.SET_PAGE]: handleSetPage,
}
